// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_u3-0";
export var checkoutRateBadgeLink = "_u3-1";